import React, { Suspense, useEffect } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import woothee from 'woothee';

// dynamic import
const SurveyWithAuthGate = React.lazy(() =>
  import(/* webpackChunkName: "SurveyWithAuthGate" */ 'features/SurveyWithAuthGate').then((m) => ({
    default: m.SurveyWithAuthGate,
  })),
);
const Backend = React.lazy(() => import(/* webpackChunkName: "Backend" */ 'containers/Backend'));
const Completed = React.lazy(
  () => import(/* webpackChunkName: "Completed" */ 'components/common/Completed'),
);
const Closed = React.lazy(
  () => import(/* webpackChunkName: "Closed" */ 'components/common/Closed'),
);
const BaseNotFound = React.lazy(
  () => import(/* webpackChunkName: "BaseNotFound" */ 'components/common/NotFound'),
);
const SurveyError = React.lazy(() =>
  import(/* webpackChunkName: "SurveyError" */ 'features/SurveyError').then((m) => ({
    default: m.SurveyError,
  })),
);

type Props = {
  isInitializedXCSRFToken: boolean;
  onRequestFetchXCSRFToken: () => void;
  setDeviceVariant: (userDevice: string) => void;
};

const App = (props: Props) => {
  const { isInitializedXCSRFToken, onRequestFetchXCSRFToken, setDeviceVariant } = props;
  const userAgent = woothee.parse(navigator.userAgent);
  const userDevice = userAgent.category;

  useEffect(() => {
    onRequestFetchXCSRFToken();
    setDeviceVariant(userDevice);
  }, []);

  if (!isInitializedXCSRFToken) return null;

  return (
    <Suspense fallback={null}>
      <Switch>
        {/* survey_uuid 不明の OAuth エラー用。/surveys/:id に :id="error" と誤マッチさせないため前に置く */}
        <Route exact path='/surveys/error' component={SurveyError} />
        <Route path='/surveys/:id' component={SurveyWithAuthGate} />
        <Route path={['/admin', '/backyard']} component={Backend} />
        <Route exact path='/' render={() => <Redirect to='/admin/sign_in' />} />
        <Route path='/completed' component={Completed} />
        <Route path='/closed' component={Closed} />
        <Route path='/' component={BaseNotFound} />
      </Switch>
    </Suspense>
  );
};

export default App;
